import { render, staticRenderFns } from "./SoonList.vue?vue&type=template&id=edd84932&scoped=true&"
import script from "./SoonList.vue?vue&type=script&lang=js&"
export * from "./SoonList.vue?vue&type=script&lang=js&"
import style0 from "./SoonList.vue?vue&type=style&index=0&id=edd84932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd84932",
  null
  
)

export default component.exports